import React from "react"
import { Box, Button, Image, VStack, StackProps } from "@chakra-ui/react"
import { useRoutes } from "@app/hooks/useRoutes"
import Link from "@app/components/Link"

import { useScavengerHunt } from "@app/hooks/useScavengerHunt"

type Props = StackProps & {
  tags: string[]
  layout?: string
}

const ScavengerHunt: React.FC<Props> = ({ tags, layout, ...rest }) => {
  const { getScavengerHuntFromTags } = useScavengerHunt()
  const scavengerHunt = getScavengerHuntFromTags(tags)
  const { anyUrlResolver } = useRoutes()

  return scavengerHunt ? (
    <VStack alignItems="flex-start" {...rest}>
      {scavengerHunt.enabled && (
        <Box
          position="absolute"
          top={layout === "pdp" ? 4 : "auto"}
          bottom={layout === "pdp" ? "auto" : 4}
          right={layout === "pdp" ? 4 : "auto"}
          left={layout === "pdp" ? "auto" : 4}
          alignItems="center"
          maxW={layout === "pdp" ? "180px" : "150px"}
          width={{ base: "40%", md: "full" }}
          animation="wiggle 2.5s infinite"
          zIndex="9"
        >
          <Button as={Link} to={anyUrlResolver(scavengerHunt.link)?.url} textDecoration="none">
            <Image src={scavengerHunt?.image?.asset?.url} alt="ScavengerHunt" width="100%" />
          </Button>
        </Box>
      )}
    </VStack>
  ) : null
}

export default React.memo(ScavengerHunt)
